import { render } from "./BasePanel.vue?vue&type=template&id=62ac4497&scoped=true"
import script from "./BasePanel.vue?vue&type=script&lang=js"
export * from "./BasePanel.vue?vue&type=script&lang=js"

import "./BasePanel.vue?vue&type=style&index=0&id=62ac4497&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ac4497"]])

export default __exports__